$(document).ready(function () {
  $(document).on('click', '.help_me_choose', function () {
    $('body').prepend('<div class="overlay1"></div>')
    $('.help_me_choose_popup').addClass('active_popup')
  })
  $(document).on('click', '.close_btn', function () {
    $('.help_me_choose_popup').removeClass('active_popup')
    $('.overlay1').remove()
  })
  $(document).on('click', '.overlay1', function () {
    $('.overlay1').remove()
    $('.help_me_choose_popup').removeClass('active_popup')
  })

  $('.landing_faqs_wrapper .set > a').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active')
      $(this).siblings('.landing_faqs_wrapper .content').slideUp(200)
    } else {
      $(this).find('i').removeClass('fa-plus').addClass('fa-minus')
      $('.landing_faqs_wrapper .set > a').removeClass('active')
      $(this).addClass('active')
      $('.landing_faqs_wrapper .content').slideUp(200)
      $(this).siblings('.landing_faqs_wrapper .content').slideDown(200)
    }
  })

  $('.press-slider-text').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.press-slider-img',
  })
  $('.press-slider-img').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.press-slider-text',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    variableWidth: true,
    infinite: false,
    arrows: false,
  })

  $('.left-content-bundle').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.thumb-left-content-bundle',
    speed: 500,
    infinite: true,
  })

  $('.thumb-left-content-bundle').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.left-content-bundle',
    arrows: false,
    dots: false,
    focusOnSelect: true,
    speed: 500,
    infinite: true,
  })

  if (screen && screen.width < 768) {
    $('.tails-of-transformation-wrapper .row').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      touchMove: false,
    })

    $('.help_me_choose_popup .row').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      touchMove: false,
    })
  }
  $('input[data-handle="all-products"]').trigger('click')
})
